import { render, staticRenderFns } from "./Denounce-questions.vue?vue&type=template&id=32703dc8&scoped=true"
import script from "./Denounce-questions.vue?vue&type=script&lang=js"
export * from "./Denounce-questions.vue?vue&type=script&lang=js"
import style0 from "./Denounce-questions.vue?vue&type=style&index=0&id=32703dc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32703dc8",
  null
  
)

export default component.exports